 
    const buttons = document.querySelectorAll('.kiss-dropdown__main-button'); 
  
    buttons.forEach(button => {
      let menu =  button.closest(".kiss-btn-with-dropdowns").querySelector('.kiss-dropdowns__menu');
      button.setAttribute('aria-expanded', 'false'); 
      menu.setAttribute('id', `dropdown-menu-${Array.prototype.indexOf.call(buttons, button)}`);
      button.setAttribute('aria-controls', menu.id);
  
      button.addEventListener('click', function() {
        console.log("Clicked");
        const expanded = button.getAttribute('aria-expanded') === 'true' || false;
        button.setAttribute('aria-expanded', !expanded);
        menu.setAttribute('aria-hidden', expanded);
      });
  
      button.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowDown' || event.key === 'Enter') {
          event.preventDefault();
          const firstMenuItem = menu.querySelector('[role="menuitem"] a');
          if (firstMenuItem) {
            firstMenuItem.focus();
          }
        }
      });
  
      menu.addEventListener('keydown', function(event) {
        const menuItems = Array.from(menu.querySelectorAll('[role="menuitem"] a'));
        const currentIndex = menuItems.indexOf(document.activeElement);
        
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          const nextIndex = (currentIndex + 1) % menuItems.length;
          menuItems[nextIndex].focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          const prevIndex = (currentIndex - 1 + menuItems.length) % menuItems.length;
          menuItems[prevIndex].focus();
        } else if (event.key === 'Escape') {
          button.focus();
          button.click();
        }
      });
  
      document.addEventListener('click', function(event) {
        if (!button.contains(event.target) && !menu.contains(event.target)) {
          button.setAttribute('aria-expanded', false);
          menu.setAttribute('aria-hidden', true);
        }
      });
    });
 